import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div id=\"about\"><div class=\"bigTitle\">诊断揭晓</div><h1>中国变应性鼻炎诊断和治疗指南（2022）</h1><p style=\"margin-top:0.1rem;\"> AR 的诊断应根据患者典型的过敏病史、临床表现以及与其一致的过敏原检测结果而作出 </p><p> 结合患者主诉、体征及皮肤试验结果，患者诊断为： </p><div class=\"detail\" style=\"margin:0 auto;margin-top:0.2rem;padding-left:3.6rem;\"> 变应性鼻炎 </div><div class=\"detail\" style=\"margin:0 auto;padding-left:1.6667rem;\"> 疾病严重程度：中-重度变应性鼻炎 </div></div>", 1)
const _hoisted_2 = { class: "zhentan" }
const _hoisted_3 = { class: "ip" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("div", null, " 中国医师协会呼吸医师分会,等.中国急救医学 2012年32卷11期, 961-965页 ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        width: "2.44rem",
        height: "3.5333rem",
        "vertical-align": "left",
        src: require('../assets/ok.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_image, {
        class: "footBtn",
        onClick: $options.nexStept,
        width: "5.64rem",
        height: "1.3333rem",
        src: require('../assets/jxbtn.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ]),
    _hoisted_4,
    _hoisted_5
  ], 64))
}